import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { questionnaireLinkUrl } from '@/lib/questionnaireLink/questionnaireLink';

/**
 * «نسخ رابط الاستبيان» (#125): copies the public `/q` link for the team to
 * share themselves (WhatsApp, groups). The system sends nothing.
 */
export function CopyQuestionnaireLinkButton() {
  const { t, dir } = useLanguage();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(questionnaireLinkUrl(window.location.origin));
      toast.success(t('common.questionnaireLink.copied'));
    } catch (error) {
      console.error('Error copying the questionnaire link:', error);
      toast.error(t('common.questionnaireLink.copyFailed'));
    }
  };

  return (
    <Button variant="outline" onClick={copy} data-testid="copy-questionnaire-link">
      <Copy className={`h-4 w-4 ${dir === 'rtl' ? 'ml-2' : 'mr-2'}`} />
      {t('common.questionnaireLink.copy')}
    </Button>
  );
}
